const ITEMS = [
  "India Race Travel",
  "Global Running Journeys",
  "Virtual Race Arena",
  "Race Travel",
  "Verified Leaderboards",
  "Finish-Line Energy",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative border-y border-[#0D1117]/10 bg-[#FBF9F5] py-6 sm:py-8 overflow-hidden"
    >
      <div className="marquee-track flex whitespace-nowrap w-max">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif text-xl sm:text-2xl lg:text-3xl font-light italic text-[#374151] px-6 sm:px-10">
              {item}
            </span>
            <span className="text-[#FF4E00] text-sm">&#10022;</span>
          </span>
        ))}
      </div>
    </div>
  );
}
